import React from 'react'

import { Button } from 'common/components'

import './styles.less'

type OptInButtonProps = {
  disabled?: boolean
  loading?: boolean
  onClick?: React.MouseEventHandler<HTMLElement>
}
export default function OptInButton(props: OptInButtonProps) {
  return (
    <Button className={'opt-in-btn'} {...props}>
      <i className="far fa-thumbs-up mr-4"></i> Opt In
    </Button>
  )
}
